/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  //console.log(new Date().toLocaleDateString("en-CA"));
  var filterCurrency = function filterCurrency(check) {
    if (check == 'true') {
      if (localStorage.getItem("filter") != "usd") localStorage.setItem("filter", "usd");else localStorage.setItem("filter", "all");
    }

    if (localStorage.getItem("filter") != "usd") {
      $(".filter").html("USD");
      $(".economy").show();
    } else {
      $(".filter").html("ALL");
      $(".economy").hide();
      $(".economy-USD").show();
    }
  };

  var checkNews = function checkNews() {
    $(".content-news").html("\n  <tr>\n    <td class=\"label-cell\">Loading...</td>\n    <td class=\"numeric-cell\"></td>\n    <td class=\"numeric-cell\"></td>\n    <td class=\"numeric-cell\"></td>\n  </tr>\n  ");
    $(".thedate").html("Event");
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/news.php',
      success: function success(data) {
        //console.log("Output:" + data);
        data = JSON.parse(data); //console.log(data);

        var newsCard = "";

        for (var i = 0; i < data.length; i++) {
          if (data[i].data == null) continue;
          var datestring = data[i].data.replace(" ", "T");
          datestring = datestring + ".000Z";
          var date = new Date(datestring);
          var time = date.toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute: '2-digit'
          });
          var today = new Date().toLocaleDateString("en-CA");
          $(".thedate").html("Event (" + today + ")");
          time = time.replace(" AM", "am");
          time = time.replace(" PM", "pm");
          var impact = "";
          var color = "";

          if (data[i].impact == 1) {
            impact = "<img src='static/images/Fire1.png' width=\"120%\"/>";
          }

          if (data[i].impact == 2) {
            impact = "<img src='static/images/Fire2.png' width=\"120%\"/>";
            color = "style='background-color:#391907'";
          }

          if (data[i].impact == 3) {
            impact = "<img src='static/images/Fire3.png' width=\"120%\"/>";
            color = "style='background-color:#390707'";
          }

          if (data[i].data.includes(today)) newsCard += "\n          <tr class=\"economy economy-" + data[i].economy + "\" " + color + ">\n            <td class=\"label-cell\"><span style=\"font-size:10px;color:gray\">" + time + "</span></td>\n            <td class=\"numeric-cell\">" + data[i].economy + "</td>\n            <td class=\"numeric-cell\">" + impact + "</td>\n            <td class=\"label-cell\"><span style=\"font-size:10px;\">" + data[i].name + "</span></td>\n          </tr>\n        ";
        }

        $(".content-news").html(newsCard);
        filterCurrency('false');
      }
    });
  };

  $on('pageInit', function () {
    $(".filter").html("");
    checkNews();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">

      <div class="left">
        <a href="#" class="link filter" @click="${()=>filterCurrency('true')}" >
          USD
        </a>
      </div>
      <div class="title">News</div>
      <div class="right">
        <a href="#" class="link" @click="${checkNews}">
          <i class="icon f7-icons" >arrow_clockwise</i>
        </a>
      </div>
    </div>
  </div>
  <div class="page-content">
  <div class="control-size">
    <div class="card data-table" style="margin: 0px; background-color: #151924;" >
      <table>
        <thead>
          <tr>
            <th class="label-cell" width="10%">Time</th>
            <th class="numeric-cell" width="10%">Cur.</th>
            <th class="numeric-cell" width="10%">Imp.</th>
            <th class="label-cell thedate" width="70%">Event</th>
          </tr>
        </thead>
        <tbody class="content-news">
          <tr>
            <td class="label-cell">Loading...</td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'ab8e6602dc';
export default framework7Component;